import Vue from 'vue'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import store from './store/store'
import { db, auth } from '@/firebase/init'
import logs from './mixins/adminLogs';
import hostingAccountLogMixin from "./mixins/hostingAccountLogMixin";
import VueClipboard from 'vue-clipboard2';
import Notifications from "vue-notification";
import veeValidatePlugin from "@/plugin/veeValidatePlugin";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';



Vue.use( CKEditor );
var VueCookie = require('vue-cookie');
// Tell Vue to use the plugin
Vue.use(VueCookie);
Vue.use(VueToast);

require('./filters');

const base = axios.create({
	baseURL: "https://api-dev.bigscoots.com/"
});
const reminderService = axios.create({
    baseURL: "https://wpo-reminder.bigscoots.com/"
});
const reportService = axios.create({
	baseURL: "https://wpo-reports.bigscoots.com/"
});

const monitorService = axios.create({
	baseURL: "https://wpo-monitors.bigscoots.com/"
});
const patchStackService = axios.create({
	baseURL: "https://patchstack-wpo.bigscoots.com/"
});

const pluginService = axios.create({
	baseURL: "http://localhost:3000/"
});

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

Vue.directive('lowercase', {
	update (el) {
		el.value = el.value.toLowerCase();
	},
});


async function errorResponseHandler(error) {
	const {config, data, status} = error.response
	const errorObj = {
		apiPath: config.url || '',
		errorCode: status || 0,
		errorMessage: data.message || '',
		createdAt: new Date().toISOString(),
		payload: config.data || '',
		from: 'Admin'
	}
	console.log('error', errorObj)

	try {
		await db.collection('apiErrorLogs').add(errorObj)
	}
	catch (e) {
		console.log('error', e.toString())
	}
	let responseMessage = '';
	let errorWrap = {
		response: {
			data: {
				message: ''
			}
		}
	};
    if (error.response) {
		return Promise.reject(error);
	} else if (error.request) {
        responseMessage = error.request ? error.request : "Error response from server";
	} else {
		responseMessage = error.message;
	}
	errorWrap.response.data.message = responseMessage;
	return Promise.reject(errorWrap);
}

// apply interceptor on response
base.interceptors.response.use(
	response => response,
	errorResponseHandler
);

base.interceptors.request.use(async config => {
	const freshToken = await auth.currentUser.getIdToken();
	if(config.data === undefined){
		return config;
	}
	config.data.token = freshToken;
	await store.dispatch('updateToken', freshToken);
	return config;

}, (error) => {
	return Promise.reject(error)
});

reminderService.interceptors.response.use(
	response => response,
	errorResponseHandler
);
reportService.interceptors.response.use(
	response => response,
	errorResponseHandler
);

reminderService.interceptors.request.use(async config => {
	const freshToken = await auth.currentUser.getIdToken();
	if(config.data === undefined){
		return config;
	}
	config.data.token = freshToken;
	await store.dispatch('updateToken', freshToken);
	return config;

}, (error) => {
	return Promise.reject(error)
});
patchStackService.interceptors.request.use(async config => {
	const freshToken = await auth.currentUser.getIdToken();
	if(config.data === undefined){
		return config;
	}
	config.data.token = freshToken;
	await store.dispatch('updateToken', freshToken);
	return config;

}, (error) => {
	return Promise.reject(error)
});
reportService.interceptors.request.use(async config => {
	const freshToken = await auth.currentUser.getIdToken();
	if(config.data === undefined){
		return config;
	}
	config.data.token = freshToken;
	await store.dispatch('updateToken', freshToken);
	return config;

}, (error) => {
	return Promise.reject(error)
});

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
Vue.use(Notifications);
Vue.use(veeValidatePlugin);


Vue.prototype.$http = base;
Vue.prototype.$reminderService = reminderService;
Vue.prototype.$reportService = reportService;
Vue.prototype.$monitorService = monitorService;
Vue.prototype.$patchStackService = patchStackService;
Vue.prototype.$pluginService = pluginService;
Vue.config.productionTip = true;
Vue.mixin(logs);
Vue.mixin(hostingAccountLogMixin);

let app = null;

// ⚡ Wait for firebase auth to init before creating the Vue app
auth.onAuthStateChanged(() => {
  // init app if not already created
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})

export const eventBus = new Vue()
